// September 28, 2026 at 1:00 PM in Addis Ababa (UTC+03:00).
export const EXCLUSIVE_CAMPAIGN_ENDS_AT = '2026-09-28T10:00:00.000Z';
